// ============================================================================
// @energyos/roof-core · kwp.ts — Leistung & Packdichte
// ----------------------------------------------------------------------------
// Reine Umrechnungen. kWp = Modulanzahl × Wp / 1000. Packdichte = belegte
// Modulfläche / Brutto-Dachfläche (horizontal projiziert).
// ============================================================================
/** Installierte Leistung in kWp aus Modulanzahl und Nennleistung (Wp). */
export function kwpFromCount(count, moduleWp) {
    const kwp = (count * moduleWp) / 1000;
    return Math.round(kwp * 1000) / 1000;
}
/** Packdichte (0–1): belegte Modulfläche / nutzbare Bezugsfläche. */
export function packingDensity(placedAreaM2, referenceAreaM2) {
    if (!(referenceAreaM2 > 0))
        return 0;
    return placedAreaM2 / referenceAreaM2;
}
//# sourceMappingURL=kwp.js.map